import { StyleSheet } from 'react-native';

import {
  ActionTile,
  IconAdd,
  IconMoney,
  IconRedeem,
  ListItemGroup,
  ListItemLinkPressable,
  Text,
  XStack,
  YStack,
  tokens,
} from '@fhs/ui';

import { BalanceIcon } from '../../components/balance-icon';
import { GiftCardImage } from '../../components/gift-card-image/gift-card-image';
import { GiftCardNumber } from '../../components/gift-card-number';
import { useGiftCardContext } from '../../state/gift-card';

import { GiftCardsProps } from './types';

export function GiftCardsMobile(props: GiftCardsProps) {
  const { formattedBalance, balanceUpdated, hasGiftCard } = useGiftCardContext();

  return (
    <YStack style={styles.container}>
      <XStack style={styles.actionTilesWrapper}>
        <ActionTile
          Icon={<IconAdd size={24} color={tokens.colors.$houseRedDarken} />}
          title="Add Gift Card"
          subtitle="Do you have an existing gift card?"
          onPress={props.onAddGiftCardPress}
        />
        <ActionTile
          Icon={<IconMoney size={24} color={tokens.colors.$houseRedDarken} />}
          title="Check Balance"
          subtitle="Check the balance of your physical gift card"
          onPress={props.onCheckBalancePress}
        />
      </XStack>

      {hasGiftCard ? (
        <>
          <YStack>
            <GiftCardImage />
            <GiftCardNumber
              lastDigits={props.lastDigits}
              onPress={props.onPressShowCardNumber}
              isRedacted={props.isCardNumberRedacted}
              isLoading={props.isCardNumberLoading}
              cardNumber={props.cardNumber}
              pin={props.pin}
            />
          </YStack>
          <YStack style={{ marginTop: 16 }}>
            <ListItemGroup
              items={[
                {
                  render: ({ isFirstItem, isLastItem }) => (
                    <ListItemLinkPressable
                      titleFontWeight="semibold"
                      minHeightStyle="content"
                      isFirstItem={isFirstItem}
                      isLastItem={isLastItem}
                      title={props.isDigitalBalanceLoading ? '' : formattedBalance}
                      titleStyle={props.isDigitalBalanceLoading ? styles.textSkeleton : undefined}
                      subtitle="Card Balance"
                      icon={<BalanceIcon animate={balanceUpdated} />}
                      onPress={props.onSeeHistoryPress}
                      indicatorText="See History"
                      indicatorTextWeight="semibold"
                      indicatorTextStyle={{
                        color: tokens.colors.$houseDark,
                      }}
                    />
                  ),
                },
              ]}
            />
          </YStack>
        </>
      ) : (
        <YStack style={styles.emptyStateContainer}>
          <IconRedeem size={80} color={tokens.colors.$blackOpacity10} />
          <Text weight="semibold" style={styles.emptyStateTextTitle}>
            Bring Your Gift Card to the App
          </Text>
          <Text style={styles.emptyStateTextSubtitle}>
            Got a physical gift card? Add it here to turn it digital. Keep it all in one place.
          </Text>
        </YStack>
      )}
    </YStack>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: tokens.colors.$white,
  },
  actionTilesWrapper: {
    gap: 16,
    paddingTop: 16,
    paddingBottom: 16,
  },
  textSkeleton: {
    maxWidth: 60,
    height: 18,
    borderRadius: 3,
    backgroundColor: tokens.colors.$blackOpacity10,
  },
  emptyStateContainer: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  emptyStateTextTitle: {
    fontSize: 18,
    marginTop: 16,
    marginBottom: 8,
    lineHeight: 25.2,
  },
  emptyStateTextSubtitle: {
    lineHeight: 19.6,
    textAlign: 'center',
  },
});
